/* eslint-disable max-len */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import './dealer-search.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
    createErrorObject,
    errorAlertBar,
} from '../../shared/services/alert-bar';
import Dealer from '../../../../sharedmodules/state/dealer';
import DealerSearchCriteria from './dealer-search-criteria';
import DealerSearchHeader from './dealer-search-header';
import DealerSearchParams from '../state/dealer-search-params';
import DealerSearchResult from './dealer-search-result';
import KeyValuePair from '../../../../sharedmodules/state/key-value-pair';
import PropTypes from 'prop-types';
import React from 'react';
import WarrantyLoadingIndicator from '../../shared/components/warranty-loading-indicator';
import { translate } from '../../../../sharedmodules/services/translation-service';

function handleDealerSearchClick(prop) {

    if (prop.isDealerSearchValid) {

        prop.actions.updateDealerResults(prop.auth.getAccessToken, prop.searchParams);

    } else {

        errorAlertBar(createErrorObject(translate('DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT')));

    }

}

function handleDealerSearchInputChange(name, value, action) {

    const processedValue = (name === 'account') ? value.toUpperCase() : value;

    action.updateSearchParams(name, processedValue);

}

function handleDealerSearchInputDivisionChange(value, prop) {

    prop.actions.updateSearchDivisionParam(value);

}

function handleDealerSelectClick(dealer, prop) {

    prop.actions.updateNewTransferNewDealer(dealer);
    prop.actions.updateDealerSearchModalVisibility(prop.isModalVisible);

}

class DealerSearch extends React.Component {

    componentWillMount() {

        this.props.actions.resetDealerResults();
        this.props.actions.resetSearchParams();
        this.props.actions.updateDivisionParams(this.props.auth.getAccessToken);

    }

    render() {

        const { dealers } = this.props;

        let dealerResults;

        if (dealers.length) {

            dealerResults = dealers.map((dealer) => (
                <DealerSearchResult
                    dealer={dealer}
                    key={dealer.account}
                    onDealerSelectClick={(e) => handleDealerSelectClick(e, this.props)}
                />
            ));

        } else if (this.props.hasSearchRun) {

            dealerResults = (
                <span className="empty">
                    <FormattedMessage id="NO_RESULTS_FOUND" />
                </span>
            );

        }

        return (
            <section className="dealer-search">
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0} />
                <DealerSearchHeader onDealerSearchClick={() => handleDealerSearchClick(this.props)} />
                <DealerSearchCriteria
                    actions={this.props.actions}
                    division={this.props.division}
                    onDealerSearchDivisionInput={(e) => handleDealerSearchInputDivisionChange(e, this.props)}
                    onDealerSearchInput={handleDealerSearchInputChange}
                    searchParams={this.props.searchParams}
                />
                <span className="dealer-search-results">{dealerResults}</span>
            </section>
        );

    }

}

DealerSearch.displayName = 'DealerSearch';
DealerSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    auth: PropTypes.object,
    busyCounter: PropTypes.number.isRequired,
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    division: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    hasSearchRun: PropTypes.bool.isRequired,
    isDealerSearchValid: PropTypes.bool.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    searchParams: PropTypes.instanceOf(DealerSearchParams).isRequired,
};

export default injectIntl(DealerSearch);
